import { getParsedStorageItem, setStorageItem, STORAGE_EVENT } from '@utils/storageHelper'

export const GUIDED_LOGIN_KEY = {
  THANK_YOU_PAGE: 'guided_login_thank_you_page',
} as const

export type GuidedLoginKey = (typeof GUIDED_LOGIN_KEY)[keyof typeof GUIDED_LOGIN_KEY]

interface GuidedLoginProps {
  key: GuidedLoginKey
  campaignCode: string
}

const handleSetExpiredTimestamp = (key: GuidedLoginKey, campaignCode: string, expiredTimestamp: number) => {
  setStorageItem(`${key}_${campaignCode}`, expiredTimestamp.toString(), STORAGE_EVENT.localStorage)
}

const getExpiredTimestamp = (key: GuidedLoginKey, campaignCode: string) => {
  const item = getParsedStorageItem(`${key}_${campaignCode}`, STORAGE_EVENT.localStorage)

  if (Number.isNaN(Number(item))) {
    return -Infinity
  }

  return Number(item)
}

export function storageGuidedLogin(props: GuidedLoginProps) {
  const { key, campaignCode } = props
  const expiredTimestamp = getExpiredTimestamp(key, campaignCode)

  const isExpired = expiredTimestamp ? Date.now() > Number(expiredTimestamp) : true

  const setExpiredTimestamp = (expiredTimestamp: number) => {
    handleSetExpiredTimestamp(key, campaignCode, expiredTimestamp)
  }

  return {
    isExpired,
    setExpiredTimestamp,
  }
}
